import styled from 'styled-components';
import getContrastColor from '@utils/getContrastFontColor';

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  .react-datepicker-popper {
    z-index: 1000;
  }

  .react-datepicker {
    font-family: ${({ theme }) => theme.bodyFont};
    border-radius: 0;
    padding: 20px;

    &__day-names {
      margin-top: 10px;
    }

    &__navigation {
      top: 30px;

      &--previous {
        left: 30px;
      }
      &--next {
        right: 30px;
      }
    }

    &__header {
      background: none;
      border: none;
    }

    &__current-month,
    &-time__header,
    &-year-header {
      font-weight: ${({ theme }) => theme.fontWeights.normal};
    }

    &__day-name,
    &__day {
      width: 40px;
      line-height: 40px;
      margin: 0;
    }

    &__day {
      margin: 0;
      border-radius: 0;

      &--in-selecting-range {
        background: #f7f7f7;
        color: #444;
      }

      &--in-range {
        background: #e4e4e4;
        color: #444;
      }

      &--today {
        color: ${({ theme }) => theme.primaryColour};
      }

      &--keyboard-selected,
      &--selected,
      &--range-start,
      &--range-end {
        background-color: ${({ theme }) => theme.primaryColour};
        color: ${({ theme }) => getContrastColor(theme.primaryColour, '#444444', '#ffffff')};
      }
    }

    &__triangle {
      display: none;
    }
  }
`;
